/**
 * @generated SignedSource<<c92ede26402c3bd48094ddc7591bdf17>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateChildrenPreferenceCriteriaInput = {
  childrenPreferenceIds?: ReadonlyArray<any | null | undefined> | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type useChildrenPreferenceCriteriaMutation$variables = {
  input: UpdateChildrenPreferenceCriteriaInput;
};
export type useChildrenPreferenceCriteriaMutation$data = {
  readonly updateChildrenPreferenceCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useChildrenPreferenceCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useChildrenPreferenceCriteriaMutation = {
  response: useChildrenPreferenceCriteriaMutation$data;
  variables: useChildrenPreferenceCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChildrenPreferenceCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateChildrenPreferenceCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateChildrenPreferenceCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useChildrenPreferenceCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChildrenPreferenceCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateChildrenPreferenceCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateChildrenPreferenceCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "ChildrenPreferenceCriterionConnection",
                    "kind": "LinkedField",
                    "name": "childrenPreferenceCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChildrenPreferenceCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "childrenPreferenceId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "childrenPreferenceCriteria(orderBy:[\"CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba90e59c019a0733e1a258220b01174f",
    "id": null,
    "metadata": {},
    "name": "useChildrenPreferenceCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useChildrenPreferenceCriteriaMutation(\n  $input: UpdateChildrenPreferenceCriteriaInput!\n) {\n  updateChildrenPreferenceCriteria(input: $input) {\n    query {\n      ...useChildrenPreferenceCriteria_query\n      id\n    }\n  }\n}\n\nfragment useChildrenPreferenceCriteria_query on Query {\n  currentUser {\n    childrenPreferenceCriteria(orderBy: [CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC]) {\n      nodes {\n        childrenPreferenceId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3eb2746ee1a849b46132bd66c0f77813";

export default node;
